import type { NearestMinutes } from "@@/shared/nearest-minutes";
import { z } from "zod";
import {
    getTimeOfDay,
    getTimeOfDayRounded,
} from "../../utilities/date-and-time/time-of-day";
import { generateId } from "../../utilities/generate-id";
import type {
    IsoAndUnixTimestamp} from "../date-time/iso-and-unix";
import {
    isoAndUnixFactory,
    isoAndUnixZodSchema,
} from "../date-time/iso-and-unix";
import { idZodSchema } from "../id";
import type { TimeRange } from "./time-range";

type TimeSpot = {
    readonly _id: string;
    readonly _type: "TIME_SPOT";
    readonly start: IsoAndUnixTimestamp;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isTimeSpot = (time: any): time is TimeSpot =>
    "_type" in time && time._type === "TIME_SPOT";
const timeSpotToString = ({ start }: TimeSpot, timeZone = "Europe/Stockholm") =>
    getTimeOfDay(start, timeZone);

const timeSpotToStringRounded = (
    { start }: TimeSpot | TimeRange,
    nearestTo: NearestMinutes,
) => getTimeOfDayRounded(start, nearestTo);

const createTimeSpot = (start: Date = new Date()): TimeSpot => ({
    _id: generateId({ prefix: "time_spot__" }),
    _type: "TIME_SPOT",
    start: isoAndUnixFactory(start),
});

const timeSpotZodSchema: z.ZodSchema<TimeSpot> = z.object({
    _id: idZodSchema,
    _type: z.literal("TIME_SPOT"),
    start: isoAndUnixZodSchema,
});

export {
    createTimeSpot,
    isTimeSpot,
    timeSpotToString,
    timeSpotToStringRounded,
    timeSpotZodSchema,
};
export type { TimeSpot };
